export default {
    phone: '(+47) 511 999 00',
    desc: 'If you call from outside of Rogaland (or from outside of Norway)',
    orgnization_number: 'Org. nr.: 914 749 360'
}